import V from 'gcl';
import C from 'vesh';

/**
 * 受限制执行顺序 必须在 EMBModuler之前
 * 监听者只知道自己的SystemID
 */
export const EMBEventModuler = class extends C.AModuler {
    constructor(
        embtamplatename = 'emb',
        encID,
        systemID, //不填写的情况下为emb专用
        getSystemSql = "emb-api.redis.getSystem") {
        super("EMBEventModuler");
        pri(this, {
            embtamplatename,
            encID,
            systemID,
            getSystemSql,
            system: []
        });
    }

    /**
     * EMB对外提供获取会话服务
     * 200 成功
     * 400* 会话相关
     * @param {*} req 
     * @param {*} rep 
     * @param {*} session 
     */
    async createToken(req, rep, session) {
        const { _, __ } = pri(this);
        //兼容EMB的web和其它系统的web需要 作为EMB站点使用别人的OrgID，作为第三方站点只能使用自己的OrgID
        const orgID = __.systemID || session.testRequired('_sys');
        const token = session.testRequired('_code');
        const encID = __.encID;
        try {
            let sys = null;
            //本地缓存5分钟
            if (!__.system[orgID] || (__.system[orgID] && __.system[orgID].refreshTime > +new Date)) {
                //过期
                let res = await session.Ni.execute('MT', __.getSystemSql, { ID: orgID, encID });
                if (res.hasData()) {
                    sys = V.json(res.single().value);
                    if (3 != sys.DelFlag) throw new Error(`4001/${orgID}系统目前不可用，请联系管理员!`);

                    if (__.system[orgID] && (__.system[orgID].Key || '').eq(sys.Key) && (__.system[orgID].IV || '').eq(sys.IV)) {
                        sys = __.system[orgID];
                    } else {
                        __.system[orgID] = sys;
                        sys.crypt = new V.des3xcrypt(sys.Key, sys.IV);
                    }
                    sys.refreshTime = new Date().add('s', 300).getTime();
                } else throw new Error(`4002/没有找到${orgID}系统信息，请联系管理员`);
            } else sys = __.system[orgID]

            const crypt = sys.crypt;
            const reqobj = V.json(crypt.decrypt(token));
            if (Math.abs(new Date().getTime() - reqobj.login) <= 60000) {
                //判断访问时间是否在60秒内，如果在60秒内可以新建会话Toke
                //如果有会话信息 直接返回可用的登陆用会话信息
                //如果没有会话信息 新建会话信息 加密sessionID返回
                const _token = crypt.encrypt(V.toJsonString({
                    sessionID: session.User.SessionID,
                    _: V.random()
                }));
                session.Login = true;
                //记录专有会话信息
                const EMB = await session.data('emb');
                EMB.data('OrgID', orgID);
                EMB.data('expire', new Date().add('h', session.AppSettings('refreshHours') || 8).getTime());

                rep.setHeader('Content-Type', V.Net.MIME.js + ';charset=utf-8');
                session.write(V.toJsonString([{ token: _token, expire: session.AppSettings('refreshHours') || 8 }]), null, true);
            } else throw new Error(`4003/_code参数已经超时，请重新生成_code参数`);
        } catch (e) {
            console.log(e.message);
            throw e;
        }
    }


    /**
     * EMB对外提供获取会话服务
     * @param {*} req 
     * @param {*} rep 
     * @param {*} session 
     */
    async checkToken(req, rep, session) {
        const { _, __ } = pri(this);
        //兼容EMB的web和其它系统的web需要
        const orgID = __.systemID || session.testRequired('_sys');
        const token = session.testRequired('_token');
        const encID = __.encID;
        try {
            let sys = null;
            //本地缓存5分钟
            if (!__.system[orgID] || (__.system[orgID] && __.system[orgID].refreshTime > +new Date)) {
                //过期
                let res = await session.Ni.execute('MT', __.getSystemSql, { ID: orgID, encID });
                if (res.hasData()) {
                    sys = V.json(res.single().value);
                    if (3 != sys.DelFlag) throw new Error(`4001/${orgID}系统目前不可用，请联系管理员!`);

                    if (__.system[orgID] && (__.system[orgID].Key || '').eq(sys.Key) && (__.system[orgID].IV || '').eq(sys.IV)) {
                        sys = __.system[orgID];
                    } else {
                        __.system[orgID] = sys;
                        sys.crypt = new V.des3xcrypt(sys.Key, sys.IV);
                    }
                    sys.refreshTime = new Date().add('s', 300).getTime();
                } else throw new Error(`4002/没有找到${orgID}系统信息，请联系管理员`);
            } else sys = __.system[orgID]

            const crypt = sys.crypt;
            const reqobj = V.json(crypt.decrypt(token));
            if (Math.abs(new Date().getTime() - reqobj.login) <= 60000) {
                //判断访问时间是否在60秒内，如果在60秒内可以新建会话Toke
                //如果有会话信息 直接返回可用的登陆用会话信息
                //如果没有会话信息 新建会话信息 加密sessionID返回
                if (!reqobj.sessionID) throw new Error('4005/_token参数代表的会话信息不存在!');
                session.reInit(reqobj.sessionID);
                await session.initSession();
                session.User.Login = true;
                session.User.UserID = session.User.UserID || ("api:" + reqobj.sessionID);
                session.testPermission = async function() {};
                if (session.param('_m')) {
                    session.querystring && delete session.querystring['_m'];
                    session.form && (delete session.form['_m'], delete session.form['_n'])
                        //重置内部方法处理
                    session.querystring['_n'] = __.embtamplatename;
                }

                session.methodname = `${session.url.pathname.substr(1, session.url.pathname.lastIndexOf(session.filename)-1)}${session.status}`.replace(/[\\\/]/g, '.').toLowerCase();
                ///_.m_prize.update 
            } else throw new Error('4004/_token参数已过期，请重新生成_token参数');
        } catch (e) {
            console.log(e.message);
            throw e;
        }
    }

    async onrequest(req, rep, session) {
        const { _, __ } = pri(this);
        try {
            //处理心跳
            if (session.param('_b')) {
                rep.setHeader('Content-Type', V.Net.MIME.txt);
                session.write(new Date().getTime() + '', null, true);
                return true;
            } else if (session.param('_code')) {
                await this.createToken(req, rep, session);
                return true;
            } else if (session.param('_token') || session.Request.headers['_token']) {
                await this.checkToken(req, rep, session);
                return false;
            } //todo 考虑session会话存在的情况下 cookie的处理
        } catch (e) {
            console.log('EMBEventModuler Error', e.stack);
            throw e;
        }
    }
}

export default {
    EMBEventModuler
};
const pri = V.pris();